import React from 'react';
import { Box, Button, Paper, Typography, Alert } from '@mui/material';
import { LockOutlined } from '@mui/icons-material';
import Lottie from 'lottie-react';
import animatedLogo from '../../assets/logos/IMPRES-Logo-Animated-Black.json';

function AccessDenied({ onBack }) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #32578b 0%, #5a7fad 100%)',
        p: 2,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 5,
          textAlign: 'center',
          maxWidth: 440,
          width: '100%',
          borderRadius: 2,
        }}
      >
        <Box sx={{ width: '200px', height: '120px', mx: 'auto', mb: 2 }}>
          <Lottie animationData={animatedLogo} loop={true} autoplay={true} />
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <LockOutlined sx={{ fontSize: 48, color: 'error.main' }} />
        </Box>

        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Access Denied
        </Typography>

        <Alert severity="error" sx={{ mb: 3, textAlign: 'left' }}>
          <Typography variant="body2">
            You are not authorized to access this application. If you believe this is in error,
            please contact the{' '}
            <a
              href="https://imprestechnology.atlassian.net/helpcenter/internal/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'inherit' }}
            >
              IMPRES IT Help Desk
            </a>
            .
          </Typography>
        </Alert>

        <Button
          variant="contained"
          fullWidth
          onClick={onBack}
          sx={{ py: 1.5, fontSize: '1rem', textTransform: 'none', fontWeight: 'bold' }}
        >
          Back to Login
        </Button>
      </Paper>
    </Box>
  );
}

export default AccessDenied;
